import type { Components, Theme } from '@mui/material/styles';
import { fontFamily } from '@/@mui/tokens/font-family';
import { fontWeights } from '@/@mui/tokens/font-weights';

export const MuiAlert: Components<Theme>['MuiAlert'] = {
  styleOverrides: {
    root: {
      display: 'flex',
      alignItems: 'center',
      fontFamily: fontFamily.fontFamilyCarbona,
      fontWeight: fontWeights.fontWeightRegular,
    },
    icon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
};
